import * as React from 'react';
import { Tooltip } from 'src/component/Global/Tooltip';
import factoryLeadIcon from "src/assets/images/factory-lead-icon.svg";
import System from 'src/helper/system';

const FactoryLeadTimeDisplay = (props) => {
    const { single_product, imageShow = true, position = 'top center' } = props;
    const { translation:t } = System;

    const renderInnerMain = (message) => {
        return (
            imageShow && (
                <Tooltip opener={() => (
                    <i className={'fa fa-exclamation-circle'} />
                )} content={() => (
                    <>
                        {message}
                    </>
                )} position={position}
                />
            )
        )
    };

    return <div className='factory-lead'>
        <div className='additional-title'>
            <div className={'font-bold'}>{t('additionalInventory')}</div>
            <span> {imageShow && <img className={'me-1'} src={factoryLeadIcon}></img>}
                {t('factoryLeadTime')}: {single_product?.FactoryLeadTime === null ?
                    <span>{t('leadTimeUnavailable')} {renderInnerMain(t('factoryLeadTimeUnavailable'))}</span> :
                    <span>{System.daysToWeeksAndDays(single_product?.FactoryLeadTime)} {renderInnerMain(t('estimatedDelivery'))}</span>}                             </span>
        </div>
    </div>;
}

export default FactoryLeadTimeDisplay;